import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Donors from './pages/Donors';
import Register from './pages/Register';
import Request from './pages/Request';
import Rewards from './pages/Rewards';
import Admin from './pages/Admin';
import './App.css';

function Nav() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: '/', label: 'ഹോം', icon: '🏠' },
    { to: '/donors', label: 'ദാതാക്കൾ', icon: '🩸' },
    { to: '/register', label: 'രജിസ്റ്റർ', icon: '✍️' },
    { to: '/request', label: 'അഭ്യർത്ഥന', icon: '🆘' },
    { to: '/rewards', label: 'റിവാർഡ്', icon: '🏆' },
  ];

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand" onClick={() => setMenuOpen(false)}>
          <span className="nav-logo">🩸</span>
          <div>
            <div className="nav-title">തോട്ടക്കാട്</div>
            <div className="nav-sub">രക്തദാന ഡയറക്ടറി</div>
          </div>
        </Link>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? '✕' : '☰'}
        </button>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {links.map(({ to, label, icon }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link ${location.pathname === to ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              <span className="nav-link-icon">{icon}</span>
              <span>{label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default function App() {
  return (
    <Router>
      <div className="app">
        <Nav />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/donors" element={<Donors />} />
            <Route path="/register" element={<Register />} />
            <Route path="/request" element={<Request />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="footer-inner">
            <p>© 2025 തോട്ടക്കാട് രക്തദാന ഡയറക്ടറി</p>
            <p className="footer-sub">ഒരു ജീവൻ രക്ഷിക്കൂ · രക്തം ദാനം ചെയ്യൂ</p>
          </div>
        </footer>

        {/* BOTTOM TAB BAR for mobile */}
        <BottomNav />
      </div>
    </Router>
  );
}

function BottomNav() {
  const location = useLocation();
  const tabs = [
    { to: '/', label: 'ഹോം', icon: '🏠' },
    { to: '/donors', label: 'ദാതാക്കൾ', icon: '🩸' },
    { to: '/register', label: 'ചേരൂ', icon: '✍️' },
    { to: '/request', label: 'അഭ്യർത്ഥന', icon: '🆘' },
    { to: '/rewards', label: 'റിവാർഡ്', icon: '🏆' },
  ];
  return (
    <nav className="bottom-nav">
      {tabs.map(({ to, label, icon }) => (
        <Link key={to} to={to} className={`bottom-tab ${location.pathname === to ? 'active' : ''}`}>
          <span className="bottom-tab-icon">{icon}</span>
          <span className="bottom-tab-label">{label}</span>
        </Link>
      ))}
    </nav>
  );
}
